/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasPagamentoGestioneDocumenti
 * @restrict E
 * @description Componente che gestisce il quarto sotto-step "Gestione Documenti" dello step "Pagamento"
 */
(function () {
  'use strict';
  var CreasPagamentoGestioneDocumentiCtrl = function (
    $http,
    $scope,
    $state,
    $stateParams,
    $window,
    $q,
    $httpParamSerializer,
    $uibModal,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    dettPraticaSrvc
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$uibModal = $uibModal;
    this.messaggiFctr = messaggiFctr;
    this.dettPraticaSrvc = dettPraticaSrvc;
    this.CONSTANTS = CONSTANTS;
    $scope.msg = labelSrvc.getLabel;
    // Workaround per bug widget fea
    this.anagraficaFea = angular.copy(
      this.dettPraticaSrvc.datiPratica.intestatario
    );
    this.anagraficaFea.naturaGiuridica = this.anagraficaFea.formaCostitutiva;

    this.spinner = this.dettPraticaSrvc.spinner;
    this.subSpinner = {
      documenti: false
    };

    this.isCompletable = false;

    this.generateDocumentLink =
      window.location.origin +
      '/MSF-PRACTICEMANAGER-MF/api/DocumentWorkflow/GeneraDocumentiGestionePolizzeCreditoPMI';

    var self = this;

    dettPraticaSrvc.isCompleteEnabled = function () {
      if (
        (dettPraticaSrvc.datiPratica.fidoNonOperativo.stato !== 'VALIDO' &&
          dettPraticaSrvc.datiPratica.fidoNonOperativo.stato !==
            'DA_EROGARE') ||
        (dettPraticaSrvc.datiPratica.stato === 'GESTIONEPOLIZZE' &&
          (dettPraticaSrvc.datiPratica.step === 5 ||
            dettPraticaSrvc.datiPratica.step === 6))
      ) {
        return false;
      }
      return self.isCompletable;
    };

    // Configuro il comportamento del pulsante completa per lo step
    dettPraticaSrvc.isCancelFinanziamentoVisible = function () {
      return true;
    };
    dettPraticaSrvc.isCancelFinanziamentoEnabled = function () {
      return true;
    };
    dettPraticaSrvc.completed = function () {
      if (!self.dettPraticaSrvc.finanziamento) {
        return;
      }

      self.spinner.pratica = true;

      self.verificaDocumenti();
    };

    /**
     * @ngdoc method
     * @name verificaDocumenti
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasPagamentoGestioneDocumenti
     * @description Esegue la verifica dei documenti per la pratica ed il finanziamento indicati
     */
    this.verificaDocumenti = function () {
      $q.all({
        verifica: self.dettPraticaSrvc.promiseCheckDocumenti(
          self.dettPraticaSrvc.datiPratica.idPratica,
          self.dettPraticaSrvc.finanziamento.idFinanziamentoPMI
        )
      }).then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response.verifica)) {
            self.spinner.pratica = false;
            return;
          }

          if (response.verifica.data.result !== true) {
            self.spinner.pratica = false;
            return;
          }
          self.messaggiFctr.addMessage({
            type: 'I',
            message: $scope.msg(
              'label.dettagliopratica.step6.sub4.completafinanziamento.checkdocumenti'
            )
          });
          self.eseguiAccettazioni();
        },
        function (reason) {
          self.spinner.pratica = false;
          self.messaggiFctr.processaResponse(reason.verifica);
        }
      );
    };

    /**
     * @ngdoc method
     * @name firmaDocumenti
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasPagamentoGestioneDocumenti
     * @description Esegue la firma dei documenti per la pratica ed il finanziamento indicati
     */
    this.firmaDocumenti = function () {
      // rimuovo pulsante cancella finanziamento
      self.dettPraticaSrvc.isCancelFinanziamentoVisible = null;
      $q.all({
        firma: self.dettPraticaSrvc.promiseFirmaDocumenti(
          self.dettPraticaSrvc.datiPratica.idPratica,
          self.dettPraticaSrvc.finanziamento.idFinanziamentoPMI
        )
      }).then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response.firma)) {
            self.spinner.pratica = false;
            return;
          }

          if (response.firma.data.result !== true) {
            self.spinner.pratica = false;
            return;
          }

          self.messaggiFctr.addMessage({
            type: 'I',
            message: $scope.msg(
              'label.dettagliopratica.step6.sub4.completafinanziamento.firma'
            )
          });
          self.completaPratica(1);
        },
        function (reason) {
          self.spinner.pratica = false;
          self.messaggiFctr.processaResponse(reason.firma);
        }
      );
    };

    /**
     * @ngdoc method
     * @name completaPratica
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasPagamentoGestioneDocumenti
     * @description Esegue la chiamata per completare la pratica
     */
    this.completaPratica = function (fase) {
      self.messaggiFctr.addMessage({
        type: 'I',
        message: $scope.msg(
          'label.dettagliopratica.step6.sub4.completafinanziamento.fase' + fase
        )
      });
      $q.all({
        completaPratica: self.dettPraticaSrvc.promiseCompletaFinanziamento(fase)
      }).then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response.completaPratica)) {
            self.spinner.pratica = false;
            return;
          }
          self.dettPraticaSrvc.datiPratica =
            response.completaPratica.data.result;
          if (fase < 4) {
            fase++;
            self.completaPratica(fase);
          } else {
            self.dettPraticaSrvc.finanziamento = null;
            self.spinner.pratica = false;
            self.dettPraticaSrvc.generaTabs();
          }
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason.completaPratica);
          self.spinner.pratica = false;
        }
      );
    };

    this.eseguiAccettazioni = function () {
      // Se nelle infoCerved ho richiestaAnagrafica a true, eseguo prima l'accettazione dei prospetti
      if (
        self.dettPraticaSrvc.datiPratica.infoCerved &&
        self.dettPraticaSrvc.datiPratica.infoCerved.richiestaAnagrafica === true
      ) {
        // Verifico se le pratiche propedeutiche sono tutte evase correttamente
        self.messaggiFctr.addMessage({
          type: 'I',
          message: $scope.msg('label.dettagliopratica.step5.checkpropedeutico')
        });
        $q.all({
          checkPropedeutiche:
            self.dettPraticaSrvc.promiseCheckPratichePropedeutiche(
              self.dettPraticaSrvc.datiPratica.idPratica
            )
        }).then(
          function (response) {
            // Se ho degli errori, esco dalla procedura
            if (
              self.messaggiFctr.processaResponse(response.checkPropedeutiche)
            ) {
              self.spinner.pratica = false;
              return;
            }
            // Richiedo i dettagli delle anagrafiche della pratica
            $q.all({
              datiAnagrafica:
                self.dettPraticaSrvc.promiseDatiClienteIntegrazione()
            }).then(
              function (response) {
                // Se ho degli errori, esco dalla procedura
                if (
                  self.messaggiFctr.processaResponse(response.datiAnagrafica)
                ) {
                  self.spinner.pratica = false;
                  return;
                }
                self.messaggiFctr.addMessage({
                  type: 'I',
                  message: $scope.msg(
                    'label.dettagliopratica.step5.avvioaccetta'
                  )
                });
                // Elaboro i dati dei firmatari e richiamo l'accettazione per ognuno di essi
                // Eseguo tutte le chiamate di accettazione
                if (
                  response.datiAnagrafica.data.result.firmatario &&
                  response.datiAnagrafica.data.result.firmatario.anagrafica
                ) {
                  self.eseguiAccettazioneFirmatariPF(
                    response.datiAnagrafica.data.result
                  );
                } else {
                  self.eseguiAccettazioneFirmatariPG(
                    response.datiAnagrafica.data.result
                  );
                }
              },
              function (reason) {
                self.spinner.pratica = false;
                self.messaggiFctr.processaResponse(reason.datiAnagrafica);
              }
            );
          },
          function (reason) {
            self.spinner.pratica = false;
            self.messaggiFctr.processaResponse(reason.checkPropedeutiche);
          }
        );

        return;
      } else {
        // Altrimenti richiamo direttamente "firmaDocumenti"
        self.firmaDocumenti();
      }
    };

    this.eseguiAccettazioneFirmatariPF = function (datiAnagrafica) {
      var firmatariCalls = {};
      var prospetti = [];

      if (
        datiAnagrafica.firmatario === undefined ||
        datiAnagrafica.firmatario === null
      ) {
        self.messaggiFctr.addMessage({
          type: 'W',
          message: $scope.msg(
            'label.dettagliopratica.step5.firmatariononvalido'
          )
        });
        self.spinner.pratica = false;
        return;
      } else if (
        datiAnagrafica.firmatario.anagrafica.prospetto === true &&
        (datiAnagrafica.firmatario.prospetto === undefined ||
          datiAnagrafica.firmatario.prospetto === null)
      ) {
        self.messaggiFctr.addMessage({
          type: 'W',
          message: $scope.msg(
            'label.dettagliopratica.step5.firmatariononvalido'
          )
        });
        self.spinner.pratica = false;
        return;
      } else if (datiAnagrafica.firmatario.anagrafica.prospetto === true) {
        var callPraticaFirmatarioProspetto =
          self.dettPraticaSrvc.promiseAccettaPersonaFisica(
            datiAnagrafica.firmatario.prospetto.idPratica
          );
        firmatariCalls[
          'firmatario' + datiAnagrafica.firmatario.prospetto.idPratica
        ] = callPraticaFirmatarioProspetto;
        prospetti.push(datiAnagrafica.firmatario.prospetto.idPratica);
      }

      if (datiAnagrafica.titolari && datiAnagrafica.titolari.length > 0) {
        for (var i = 0; i < datiAnagrafica.titolari.length; i++) {
          if (
            datiAnagrafica.titolari[i] === undefined ||
            datiAnagrafica.titolari[i] === null
          ) {
            self.messaggiFctr.addMessage({
              type: 'W',
              message: $scope.msg(
                'label.dettagliopratica.step5.firmatariononvalido'
              )
            });
            self.spinner.pratica = false;
            return;
          } else if (
            datiAnagrafica.titolari[i].anagrafica.prospetto === true &&
            (datiAnagrafica.titolari[i].prospetto === undefined ||
              datiAnagrafica.titolari[i].prospetto === null)
          ) {
            self.messaggiFctr.addMessage({
              type: 'W',
              message: $scope.msg(
                'label.dettagliopratica.step5.firmatariononvalido'
              )
            });
            self.spinner.pratica = false;
            return;
          } else if (datiAnagrafica.titolari[i].anagrafica.prospetto === true) {
            var callPraticaProspetto =
              self.dettPraticaSrvc.promiseAccettaPersonaFisica(
                datiAnagrafica.titolari[i].prospetto.idPratica
              );
            firmatariCalls[
              'firmatario' + datiAnagrafica.titolari[i].prospetto.idPratica
            ] = callPraticaProspetto;
            prospetti.push(datiAnagrafica.titolari[i].prospetto.idPratica);
          }
        }
      }

      // Se non ho prospetti, passo direttamente all'integrazione della persona giuridica
      if (prospetti.length === 0) {
        self.eseguiAccettazioneFirmatariPG(datiAnagrafica);
        return;
      }

      $q.all(firmatariCalls).then(
        function (firmatariResponse) {
          // Elaboro le risposte di tutti i prospetti
          // La chiamata ha esito positivo se la risposta è vuota
          for (var i = 0; i < prospetti.length; i++) {
            if (
              self.messaggiFctr.processaResponse(
                firmatariResponse['firmatario' + prospetti[i]]
              )
            ) {
              self.spinner.pratica = false;
              return;
            }
          }

          // Se tutte sono andate a buon fine, procedo con l'accettazione della persona giuridica
          self.messaggiFctr.addMessage({
            type: 'I',
            message: $scope.msg(
              'label.dettagliopratica.step5.accettatofirmatario'
            )
          });
          self.eseguiAccettazioneFirmatariPG(datiAnagrafica);
        },
        function (firmatariReason) {
          if (Array.isArray(firmatariReason)) {
            for (var i = 0; i < prospetti.length; i++) {
              self.messaggiFctr.processaResponse(
                firmatariReason['firmatario' + prospetti[i]]
              );
            }
          } else {
            self.messaggiFctr.processaResponse(firmatariReason);
          }
          self.spinner.pratica = false;

          return;
        }
      );
    };

    this.eseguiAccettazioneFirmatariPG = function (datiAnagrafica) {
      if (
        datiAnagrafica.giuridica === undefined ||
        datiAnagrafica.giuridica === null
      ) {
        self.spinner.pratica = false;
        self.messaggiFctr.addMessage({
          type: 'W',
          message: $scope.msg('label.dettagliopratica.step5.pgnonvalida')
        });
        return;
      } else if (
        datiAnagrafica.giuridica.anagrafica.prospetto === true &&
        (datiAnagrafica.giuridica.prospetto === undefined ||
          datiAnagrafica.giuridica.prospetto === null)
      ) {
        self.spinner.pratica = false;
        self.messaggiFctr.addMessage({
          type: 'W',
          message: $scope.msg('label.dettagliopratica.step5.pgnonvalida')
        });
        return;
      } else if (datiAnagrafica.giuridica.anagrafica.prospetto === true) {
        $q.all({
          prospettoPG: self.dettPraticaSrvc.promiseAccettaPersonaGiuridica(
            datiAnagrafica.giuridica.prospetto.idPratica,
            datiAnagrafica.giuridica.anagrafica.formaCostitutiva
          )
        }).then(
          function (prospettoPGResponse) {
            // La chiamata ha esito positivo se la risposta è vuota
            if (
              self.messaggiFctr.processaResponse(
                prospettoPGResponse.prospettoPG
              )
            ) {
              self.spinner.pratica = false;
              return;
            }

            // Se la chiamata è andata a buon fine, procedo col passaggio al firma documenti
            self.messaggiFctr.addMessage({
              type: 'I',
              message: $scope.msg('label.dettagliopratica.step5.accettatapg')
            });
            self.firmaDocumenti();
          },
          function (pgReason) {
            self.spinner.pratica = false;
            var errorMsg = JSON.parse(pgReason.data);
            if (prospettoPGResponse.status === 417) {
              messaggiSrvc.pushErrorMessage(
                labelSrvc
                  .getLabel('errors.417')
                  .replace(
                    '[ID_PRATICA]',
                    datiAnagrafica.giuridica.prospetto.idPratica
                  )
              );
              self.spinner.pratica = false;
              return;
            } else if (errorMsg && errorMsg.Messages) {
              for (var i = 0; i < errorMsg.Messages.length; i++) {
                self.messaggiFctr.addMessage({
                  type: 'E',
                  message: errorMsg.Messages[i].Message
                });
              }
            }

            return;
          }
        );
      } else {
        self.firmaDocumenti();
      }
    };

    /**
     * @ngdoc method
     * @name generaDocumenti
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasPagamentoGestioneDocumenti
     * @description Apre una finestra modale per l'inserimento di luogo e data da apporre sui documenti da generare
     */
    this.generaDocumenti = function () {
      self.subSpinner.documenti = false;
      self.isCompletable = true;
    };

    self.dettPraticaSrvc.finanziamento =
      self.dettPraticaSrvc.getFinanziamentoBozza();
    self.generaDocumenti();
  };

  CreasPagamentoGestioneDocumentiCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$window',
    '$q',
    '$httpParamSerializer',
    '$uibModal',
    'CONSTANTS',
    'LabelSrvc',
    'CreasMessaggiFctr',
    'CreasDettaglioPraticaSrvc'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'creasDettaglioPratica/creasPraticaPagamento/creasPagamentoGestioneDocumenti/creasPagamentoGestioneDocumenti.html'
    );
  };

  TemplateUrl.$inject = ['CONSTANTS'];

  var CreasPagamentoGestioneDocumentiComponent = {
    bindings: {},
    controller: CreasPagamentoGestioneDocumentiCtrl,
    controllerAs: 'creasPagamentoGestioneDocumentiCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.insuranceloanpmi.mf')
    .component(
      'creasPagamentoGestioneDocumenti',
      CreasPagamentoGestioneDocumentiComponent
    );
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/creasDettaglioPratica/creasPraticaPagamento/creasPagamentoGestioneDocumenti/creasPagamentoGestioneDocumenti.cmpt.js
// module id = 30
// module chunks = 0 1